import { useMutation } from 'react-query';

import { postDiscounts } from 'queries';
import { JsonDataItem } from 'types';
import { parseErrors, Toast } from 'helpers';
import { RootStore } from 'store';

export const useServiceDiscountsUpdate = () => {
  const { setJob } = RootStore;

  const handleMutationError = (error: JsonDataItem) => {
    Toast.show({ description: parseErrors(error).join(', '), type: Toast.Type.Error });
  };

  const handleMutationSuccess = (data: JsonDataItem) => {
    setJob(data);
  };

  const { mutate, isLoading } = useMutation(postDiscounts, {
    onError: handleMutationError,
    onSuccess: handleMutationSuccess,
  });

  const updateServiceDiscounts = (props: JsonDataItem) => {
    const { newDiscounts, serviceId } = props;

    return mutate({
      serviceId,
      discounts:
        newDiscounts?.map((discount: JsonDataItem) => {
          return {
            approved_by: discount.approverId,
            reason_id: discount.reasonId,
            discount_id: discount.discountId,
          };
        }) || [],
    });
  };

  return { updateServiceDiscounts, isLoading };
};
